import Reveal from '@/components/base/Reveal';
import { communityThreads, hotBoard } from '@/mocks/home';

export default function CommunityTalk() {
  return (
    <section id="community" className="w-full border-y border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <Reveal>
          <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <p className="flex items-center gap-2 text-sm font-medium text-primary-600">
                <span className="h-px w-8 bg-primary-500" />
                社区讨论
              </p>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                把线索摆出来，一起把话说清楚
              </h2>
            </div>
            <button
              type="button"
              className="flex h-10 w-fit items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-edit-line text-base" />
              发起讨论
            </button>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-[1.6fr_1fr]">
          <div className="flex flex-col gap-4">
            {communityThreads.map((thread, i) => (
              <Reveal key={thread.title} delay={i * 90}>
                <article className="rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-foreground-300 md:p-6">
                  <div className="flex items-center gap-3">
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary-200 text-sm font-medium text-secondary-900">
                      {thread.author.slice(0, 1)}
                    </span>
                    <span className="min-w-0">
                      <span className="block text-sm font-medium text-foreground-900">{thread.author}</span>
                      <span className="block text-xs text-foreground-500">{thread.time}</span>
                    </span>
                    <span className="ml-auto shrink-0 rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] font-medium text-accent-900">
                      {thread.tag}
                    </span>
                  </div>

                  <h3 className="mt-4 font-heading text-lg font-semibold leading-snug text-foreground-950">
                    <a href="#community" className="transition-colors hover:text-primary-600">
                      {thread.title}
                    </a>
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{thread.excerpt}</p>

                  <div className="mt-4 flex items-center gap-5 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line text-sm" />
                      {thread.replies} 条回复
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-heart-3-line text-sm" />
                      {thread.likes}
                    </span>
                    <a
                      href="#community"
                      className="ml-auto flex items-center gap-1 whitespace-nowrap font-medium text-primary-600 transition-colors hover:text-primary-700"
                    >
                      参与讨论
                      <i className="ri-arrow-right-line text-sm" />
                    </a>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>

          <Reveal delay={120} className="h-full">
            <div className="rounded-lg border border-background-200 bg-background-50 p-6 lg:sticky lg:top-24">
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-fire-line text-accent-600" />
                热议榜
              </h3>
              <ul className="mt-5 divide-y divide-background-100">
                {hotBoard.map((item) => (
                  <li key={item.rank}>
                    <a href="#community" className="group flex items-start gap-3 py-3">
                      <span
                        className={`flex h-5 w-5 shrink-0 items-center justify-center rounded font-mono text-[11px] font-semibold ${
                          item.rank <= 3
                            ? 'bg-primary-500 text-background-50'
                            : 'bg-secondary-100 text-secondary-800'
                        }`}
                      >
                        {item.rank}
                      </span>
                      <span className="min-w-0 flex-1 text-sm leading-snug text-foreground-800 transition-colors group-hover:text-primary-600">
                        {item.title}
                      </span>
                      <span className="shrink-0 font-mono text-xs text-foreground-400">{item.heat}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}